module.exports = __webpack_public_path__ + "img/img_title_judges.853baffd.png";